import type { IObjectViewModel } from '../../../interfaces';
import { SceneItemKind } from '../../../interfaces';
import type { IIndicationStrategy } from '../Indications.controller';
import type { IIndicationToolFactory } from '../Indications.factory';
import type { IndicationsService } from '../Indications.service';
import type { IValue } from '@/engine/DataFlow/Graph';
import { SplineIndicationModel } from './SplineIndication.model';
import { AreaIndicationStrategy } from './AreaIndicationStrategy';
import type { IIndicationsViewModelFactory } from '../interfaces';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import type { ICommandProcessor } from '../../core/interfaces/Command';
import type { IRemover } from '@/engine/UIPresentation/Interfaces';
import { AreaIndicationAdder } from './AreaAdder';

export class AreaToolFactory implements IIndicationToolFactory {
  private _indicationsService: IndicationsService;

  public constructor(indicationsService: IndicationsService) {
    this._indicationsService = indicationsService;
  }

  public createIndicationStrategy(
    planningAlgorithm: PlanningAlgorithm,
    commandProcessor: ICommandProcessor,
    remover: IRemover
  ): IIndicationStrategy {
    return new AreaIndicationStrategy(
      this._indicationsService,
      planningAlgorithm,
      commandProcessor,
      new AreaIndicationAdder(planningAlgorithm, this._indicationsService),
      remover
    );
  }

  public createIndicationModel(): IValue {
    return new SplineIndicationModel({ basePts: [] });
  }

  public createIndicationViewModel(
    vmFactory: IIndicationsViewModelFactory,
    phaseId: string | undefined
  ): IObjectViewModel {
    return vmFactory.createViewModel(SceneItemKind.AreaIndication, phaseId);
  }
}
